import React from 'react';
import { Admin, Resource, CustomRoutes, Layout, Menu } from 'react-admin';
import { Route } from 'react-router-dom';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import CampaignIcon from '@mui/icons-material/Campaign';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import { authProvider } from './authProvider';
import dataProvider from './dataProvider';
import { UserList, UserEdit, UserShow } from './resources/users';
import { SalesRepList, SalesRepEdit, SalesRepShow } from './resources/salesReps';
import { HomeList, HomeEdit, HomeShow } from './resources/homes';
import { ServiceList, ServiceEdit, ServiceShow } from './resources/services';
import { KnockList, KnockEdit, KnockShow } from './resources/knocks';
import { SignOrderList, SignOrderEdit, SignOrderShow } from './resources/signOrders';
import Dashboard from './Dashboard';
import Login from './Login';
import FieldSignUp from './components/FieldSignUp';
import FieldSignUpPage from './components/FieldSignUpPage';
import HoaMessaging from './components/HoaMessaging';
import HoaAdmin from './components/HoaAdmin';

const CustomMenu = () => (
  <Menu>
    <Menu.DashboardItem />
    <Menu.ResourceItem name="users" />
    <Menu.ResourceItem name="sales_reps" />
    <Menu.ResourceItem name="homes" />
    <Menu.ResourceItem name="services" />
    <Menu.ResourceItem name="knocks" />
    <Menu.ResourceItem name="sign_orders" />
    <Menu.Item
      to="/hoas"
      primaryText="HOAs"
      leftIcon={<HomeWorkIcon />}
    />
    <Menu.Item
      to="/field-signup-hub"
      primaryText="Field Sign Up"
      leftIcon={<AssignmentIndIcon />}
    />
    <Menu.Item
      to="/hoa-messaging"
      primaryText="Broadcast"
      leftIcon={<CampaignIcon />}
    />
  </Menu>
);

const CustomLayout = (props: any) => <Layout {...props} menu={CustomMenu} />;

const App = () => (
  <Admin
    dataProvider={dataProvider}
    authProvider={authProvider}
    dashboard={Dashboard}
    loginPage={Login}
    layout={CustomLayout}
  >
    <CustomRoutes>
      <Route path="/field-signup" element={<FieldSignUp />} />
      <Route path="/field-signup-hub" element={<FieldSignUpPage />} />
      <Route path="/hoas" element={<HoaAdmin />} />
      <Route path="/hoa-messaging" element={<HoaMessaging />} />
    </CustomRoutes>
    <Resource
      name="users"
      list={UserList}
      edit={UserEdit}
      show={UserShow}
    />
    <Resource
      name="sales_reps"
      options={{ label: "Sales Reps" }}
      list={SalesRepList}
      edit={SalesRepEdit}
      show={SalesRepShow}
    />
    <Resource
      name="homes"
      list={HomeList}
      edit={HomeEdit}
      show={HomeShow}
    />
    <Resource
      name="services"
      list={ServiceList}
      edit={ServiceEdit}
      show={ServiceShow}
    />
    <Resource
      name="knocks"
      list={KnockList}
      edit={KnockEdit}
      show={KnockShow}
    />
    <Resource
      name="sign_orders"
      options={{ label: "Sign Orders" }}
      list={SignOrderList}
      edit={SignOrderEdit}
      show={SignOrderShow}
    />
  </Admin>
);

export default App;
